module.exports = __webpack_public_path__ + "img/info_4.9cdcab2b.jpeg";